import React from "react";

import homepageBanner from "../../assets/Images/roots/bloomreach-black-friday-home.webp";
import cartBanner from "../../assets/Images/roots/bloomreach-black-friday-cart.webp";

const screenshots = [
  {
    title: "Homepage placement",
    src: homepageBanner,
    width: 2000,
    height: 655,
    alt: "Redacted personalized Black Friday banner above the Roots homepage holiday hero, with a Copy action",
    caption: "The offer appears above the homepage campaign hero, keeping the assigned code and Copy action together.",
  },
  {
    title: "Cart placement",
    src: cartBanner,
    width: 2000,
    height: 255,
    alt: "Redacted personalized Black Friday banner at the top of the Roots shopping cart, with a Copy action",
    caption: "The same eligible-customer message is available again at the start of the cart journey.",
  },
];

export const bloomreachBannerSlide = {
  label: "Black Friday Banner",
  content: (
    <section className="case-study-slide bloomreach-banner" aria-labelledby="bloomreach-banner-title">
      <h4 id="bloomreach-banner-title">Black Friday — Personalized Promotional Banner</h4>

      <div className="bloomreach-banner__details">
        <div>
          <h5>Problem</h5>
          <p>
            Eligible shoppers needed to find their assigned Black Friday code on the homepage and
            again in the cart, without having to search for the offer or retype it.
          </p>
        </div>
        <div>
          <h5>Implementation</h5>
          <p>
            I worked on a Bloomreach WebLayer banner for both placements, presenting the
            personalized code with a JavaScript copy-to-clipboard action. The same experience
            needed to support English and French storefronts.
          </p>
        </div>
        <div>
          <h5>Technical considerations</h5>
          <p>
            I had to keep the code and Copy action readable across page contexts and screen sizes,
            while checking audience eligibility, localized copy, and the banner's behaviour during QA.
          </p>
        </div>
      </div>

      <ul className="project-tags project-tags--modal" aria-label="Black Friday banner technology">
        {["Bloomreach", "JavaScript", "Personalization", "WebLayers"].map((tag) => (
          <li key={tag}>{tag}</li>
        ))}
      </ul>

      <div className="bloomreach-banner__screenshots">
        {screenshots.map((shot) => (
          <figure className="bloomreach-banner__shot" key={shot.title}>
            <a
              href={shot.src}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Open full-size screenshot: ${shot.title} (new tab)`}
            >
              <img
                src={shot.src}
                width={shot.width}
                height={shot.height}
                alt={shot.alt}
                loading="lazy"
                decoding="async"
              />
            </a>
            <figcaption>
              <strong>{shot.title}</strong>
              <span>{shot.caption}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  ),
};
